import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {CompleteWorkoutResult} from '../../domain/workout';
import type {WorkoutId} from '../../domain/workout-id.value-object';
import type {WorkoutRepository} from '../ports/workout.repository';

export type CompleteWorkoutInput = {
  readonly workoutId: WorkoutId;
};

export class CompleteWorkout
  implements UseCase<[CompleteWorkoutInput], CompleteWorkoutResult>
{
  constructor(private readonly repository: WorkoutRepository) {}

  execute(
    input: CompleteWorkoutInput,
  ): Promise<Result<CompleteWorkoutResult, WorkoutError>> {
    return this.repository.completeWorkout(input.workoutId);
  }
}
